import { Component, Input } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { VerificationHeadingComponent } from '../verification-heading/verification-heading.component';
import { PatientDetailsComponent } from '../patient-details/patient-details.component';
import { PatientMatchFormComponent } from '../patient-match-form/patient-match-form.component';

@Component({
    selector: 'app-validate-patient-match',
    templateUrl: './validate-patient-match.component.html',
    styleUrls: ['./validate-patient-match.component.scss'],
    imports: [VerificationHeadingComponent, PatientDetailsComponent, PatientMatchFormComponent]
})
export class ValidatePatientMatchComponent {
  constructor() {}

  @Input() capture: Capture;
  @Input() patientAttachment: PatientAttachment;
}
